<svg
  width="24px"
  height="24px"
  viewBox="0 0 24 24"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  fill="currentColor"
>
  <slot />
</svg>

<style>
  svg {
    height: 1em;
    stroke-linejoin: round;
    stroke-linecap: round;
    stroke-width: 2;
    width: 1em;
  }
</style>
